import { render, staticRenderFns } from "./CompareEvals.vue?vue&type=template&id=0271226a"
import script from "./CompareEvals.vue?vue&type=script&lang=js"
export * from "./CompareEvals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports